__turbopack_context__.v({
  "root": "tabs-module__dWOOCq__root",
});
